module.exports = __webpack_public_path__ + "fix-header.d25761b93fb31d8ab8e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fix-header.svg
// module id = ./src/assets/img/fix-header.svg
// module chunks = main